<div class="relative">
    <!-- Input Container -->
    <div class="input-container flex flex-col relative "  [ngClass]="palette">
      <!-- Icono izquierdo -->
      <i *ngIf="icon" class="icon--left icon {{icon}}"></i>

      <!-- Input -->
      <input
        #inputElement
        role="presentation"
        [attr.autocomplete]="autocomplete ? autocomplete : 'off'"
        [type]="type"
        [name]="name"
        [(ngModel)]="value"
        placeholder=" "
        [disabled]="disabled"
        (input)="onInputChange($event)"
        (focus)="onFocus()"
        (blur)="onTouchedUp()"
        class="w-full pb-2 pt-6 border-b-2  bg-transparent text-gray-600  transition-all duration-300"
      />

      <!-- Label -->
      <label
        *ngIf="label"
        [for]="name"
        [class.label-up]="isLabelUp || isFocused"
        class="absolute text-left  text-gray-500 text-base transition-all duration-300"
      >
        {{ label }}{{ formField?.hasValidator(requiredValidator) ? "*" : "" }}
      </label>

      <!-- Icono derecho -->
      <i *ngIf="iconRight" class="icon--right icon {{iconRight}}"></i>

      <!-- Botón para limpiar el campo -->
      <msc-button
        type="fab"
        icon="icon-close"
        *ngIf="value && clearBtn"
        (click)="clearInput()"
      ></msc-button>

      <!-- Botón para alternar tipo de contraseña -->
      <msc-button
        type="fab"
        [icon]="type === 'password' ? 'icon-eye-off' : 'icon-eye'"
        *ngIf="initialType === 'password'"
        (click)="toggleInputType()"
      ></msc-button>
    </div>
  </div>

<!-- Mensajes de error -->
<div class="mt-1" *ngIf="formField?.invalid || hasErrors">
    <field-errors
        class="mt-1"
        [class.hidden]="formField?.valid"
        [formField]="formField"
    ></field-errors>
</div>

<!-- Ayuda o sugerencias -->
<div class="hints mt-1" *ngIf="hints">
    <p class="text-black-400 text-xs leading-4" *ngFor="let hint of hints">
        <span><i class="icon icon-bulb text-sm"></i></span>
        <span [innerHtml]="hint"></span>
    </p>
</div>

<!-- Texto de ayuda -->
<div class="helper-text mt-1" *ngIf="helperText">
    <p
        class="text-xs leading-4"
        [ngClass]="{
            'text-success-500': hasSuccess,
            'text-error-500': hasErrors,
            'text-danger-500': hasWarning
        }"
        [innerHtml]="helperText"
    ></p>
</div>
